export default "__VITE_ASSET__DgDUQJkF__"